<template>
  <div class="full-reduction-pop">
    <van-popup
      v-model="show"
      position="bottom"
      round
      safe-area-inset-bottom
      :close-on-popstate="true"
      :style="{ 'min-height': '30%', 'max-height': '62%', 'overflow': 'auto' }"
      @close="onClose"
      closeable
      close-icon="cross"
    >
      <div class="titleName">赠品</div>
      <div class="content">
        <template v-if="giftMaterialList">
          <GoodsCard
            v-for="(item, index) in giftMaterialList"
            :key="index"
            :goodsInfo="item"
          />
        </template>
      </div>
    </van-popup>
  </div>
</template>

<script>
import GoodsCard from '@/pages/payment/couponPop/goodsCard.vue';

export default {
  components: { GoodsCard },
  props: {

    giftMaterialList: {
      type: Array,
      default: () => { },
    },
  },
  data() {
    return {
      show: true,
    };
  },
  mounted() {
  },
  methods: {
    onClose() {
      this.$emit('giveGiftsClose');
    },

  },
};
</script>
<style scoped lang="scss">
.full-reduction-pop {
  .titleName {
    color: #333;
    font-weight: 600;
    font-size: 33px;
    line-height: 45px;
    text-align: center;
    margin-top: 25px;
  }
  .content {
    height: calc(100% - 100px);
    padding: 60px 36px;
  }
}
::v-deep .van-icon-cross:before {
  color: #999;
}
::v-deep .goodItemCompont {
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
}
</style>
